import { render, staticRenderFns } from "./CityFavorites.view.vue?vue&type=template&id=aaaddfa2&scoped=true"
import script from "./CityFavorites.view.vue?vue&type=script&lang=ts"
export * from "./CityFavorites.view.vue?vue&type=script&lang=ts"
import style0 from "./CityFavorites.view.vue?vue&type=style&index=0&id=aaaddfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaddfa2",
  null
  
)

export default component.exports